'use client';

import { IconButton } from '@chakra-ui/react';
import { PanelLeftClose, PanelLeftOpen, PanelRightClose, PanelRightOpen } from 'lucide-react';
import { forwardRef } from 'react';

export const SidePanelToggleButton = forwardRef<
  HTMLButtonElement,
  {
    open: boolean;
    onClick?: () => void;
    label?: string;
    desktopOnly?: boolean;
    side?: 'left' | 'right';
    controls?: string;
  }
>(function SidePanelToggleButton(
  { open, onClick, label, desktopOnly = false, side = 'right', controls },
  ref
) {
  const Icon =
    side === 'left'
      ? open
        ? PanelLeftClose
        : PanelLeftOpen
      : open
        ? PanelRightClose
        : PanelRightOpen;
  const title = label || (open ? 'Hide side panel' : 'Show side panel');

  return (
    <IconButton
      ref={ref}
      aria-label={title}
      title={title}
      aria-expanded={open}
      aria-controls={controls}
      display={desktopOnly ? { base: 'none', lg: 'inline-flex' } : 'inline-flex'}
      variant="ghost"
      boxSize="38px"
      minW="38px"
      flexShrink={0}
      borderRadius="12px"
      color="ui.text.secondary"
      _icon={{ boxSize: '18px' }}
      _hover={{ bg: 'ui.surface.input', color: 'ui.text.primary' }}
      _focusVisible={{
        outline: '2px solid',
        outlineColor: 'accent.focusRing',
        outlineOffset: '-2px',
      }}
      onClick={onClick}
    >
      <Icon size={18} strokeWidth={1.75} aria-hidden="true" />
    </IconButton>
  );
});
